import React from 'react';
import { Select } from 'antd';
import { useUnit } from 'effector-react';
import {
  $activeLayer,
  changeActiveLayerEv,
} from '../../models/ABMarketsModel/index.js';
import style from './ABStyles.module.css';

const layers = [
  {
    label: 'Примененный тариф',
    value: 'tariff',
  },
  {
    label: 'Объем импорта',
    value: 'cost_all',
  },
  {
    label: 'Объем импорта из Казахстана',
    value: 'cost',
  },
];

function AbLayerSelector() {
  const activeLayer = useUnit($activeLayer);
  const changeActiveLayer = useUnit(changeActiveLayerEv);

  return (
    <div
      style={{
        alignItems: 'center',
        marginBottom: '20px',
        columnGap: 10,
        marginTop: 20,
      }}
    >
      <div>Выберите слой</div>
      <Select
        className={style.ab_layer_select}
        options={layers}
        value={activeLayer}
        onChange={changeActiveLayer}
        variant="borderless"
      />
    </div>
  );
}

export default AbLayerSelector;
